export default "__VITE_ASSET__BjgMHTe6__"